import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";

const connectedApps = new WeakSet();

const numberFromEnvironment = (name, fallback) => {
  const value = Number(process.env[name]);
  return Number.isFinite(value) ? value : fallback;
};

export const connectFirebaseEmulators = (app) => {
  if (
    connectedApps.has(app) ||
    process.env.REACT_APP_USE_FIREBASE_EMULATORS !== "true"
  ) {
    return;
  }

  const host = process.env.REACT_APP_FIREBASE_EMULATOR_HOST || "127.0.0.1";

  connectAuthEmulator(
    getAuth(app),
    `http://${host}:${numberFromEnvironment(
      "REACT_APP_FIREBASE_AUTH_EMULATOR_PORT",
      19099
    )}`,
    { disableWarnings: true }
  );
  connectFirestoreEmulator(
    getFirestore(app),
    host,
    numberFromEnvironment("REACT_APP_FIRESTORE_EMULATOR_PORT", 18080)
  );
  connectStorageEmulator(
    getStorage(app),
    host,
    numberFromEnvironment("REACT_APP_FIREBASE_STORAGE_EMULATOR_PORT", 19199)
  );

  connectedApps.add(app);
};
